import { RESET_STATE } from '../types/stateTypes';
import {
  DEQUEUE_ALL_BOOSTED_SYSTEM_BET_TICKET,
  DEQUEUE_ALL_TICKETS,
  DEQUEUE_TICKET,
  ENQUEUE_BOOSTED_SYSTEM_BET_TICKET,
  ENQUEUE_TICKET,
  FLUSH_CASHOUT_OFFER_UPDATES,
  REMOVE_FAILED_SYSTEM_BET_PLACED,
  REMOVE_SPECIFIC_SUCCESS_SYSTEM_BET_PLACE,
  REMOVE_SUCCESS_SYSTEM_BET_PLACED,
  SET_CASHOUT_OFFER_ACCEPTED,
  SET_CASHOUT_OFFER_REJECTED,
  SET_CASHOUT_OFFER_UNAVAILABLE,
  SET_CASHOUT_OFFER_UPDATE,
  SET_FAILED_SYSTEM_BET_PLACED,
  SET_PENDING_TICKET_STATUSES,
  SET_SUCCESS_SYSTEM_BET_PLACED,
  TicketActionType,
  TicketState,
} from '../types/ticketTypes';

export const initialTicketState: TicketState = {
  queuedTickets: [],
  pendingTickets: {},
  liveCashoutOffers: {},
  queuedBoostedSystemBetTickets: [],
  successPlacedSystemBets: [],
  failedPlacedSystemBets: [],
};

export const ticketReducer = (state = initialTicketState, action: TicketActionType): TicketState => {
  switch (action.type) {
    case RESET_STATE:
      return {
        ...initialTicketState,
      };
    case SET_PENDING_TICKET_STATUSES:
      return { ...state, pendingTickets: action.meta };
    case ENQUEUE_TICKET:
      return {
        ...state,
        queuedTickets: [...state.queuedTickets, action.meta],
      };
    case DEQUEUE_TICKET:
      return {
        ...state,
        queuedTickets: state.queuedTickets.slice(1),
      };
    case SET_CASHOUT_OFFER_UPDATE: {
      return {
        ...state,
        liveCashoutOffers: {
          ...state.liveCashoutOffers,
          [action.meta.ticketId]: {
            ...state.liveCashoutOffers[action.meta.ticketId],
            offerValue: action.meta.cashoutOffer,
          },
        },
      };
    }
    case FLUSH_CASHOUT_OFFER_UPDATES: {
      return {
        ...state,
        liveCashoutOffers: {},
      };
    }
    case SET_CASHOUT_OFFER_ACCEPTED: {
      return {
        ...state,
        liveCashoutOffers: {
          ...state.liveCashoutOffers,
          [action.meta.ticketId]: {
            ...state.liveCashoutOffers[action.meta.ticketId],
            accepted: action.meta.accepted,
            boostedCashoutOffer: action.meta.boostedCashoutOffer,
          },
        },
      };
    }
    case SET_CASHOUT_OFFER_REJECTED: {
      return {
        ...state,
        liveCashoutOffers: {
          ...state.liveCashoutOffers,
          [action.meta.ticketId]: {
            ...state.liveCashoutOffers[action.meta.ticketId],
            rejected: action.meta.rejected,
          },
        },
      };
    }
    case SET_CASHOUT_OFFER_UNAVAILABLE: {
      return {
        ...state,
        liveCashoutOffers: {
          ...state.liveCashoutOffers,
          [action.meta.ticketId]: {
            ...state.liveCashoutOffers[action.meta.ticketId],
            unavailable: action.meta.unavailable,
          },
        },
      };
    }
    case ENQUEUE_BOOSTED_SYSTEM_BET_TICKET:
      return {
        ...state,
        queuedBoostedSystemBetTickets: [...state.queuedBoostedSystemBetTickets, action.meta],
      };
    case DEQUEUE_ALL_BOOSTED_SYSTEM_BET_TICKET:
      return {
        ...state,
        queuedBoostedSystemBetTickets: [],
      };
    case SET_SUCCESS_SYSTEM_BET_PLACED: {
      return {
        ...state,
        successPlacedSystemBets: [...state.successPlacedSystemBets, action.meta],
      };
    }
    case SET_FAILED_SYSTEM_BET_PLACED: {
      return {
        ...state,
        failedPlacedSystemBets: [...state.failedPlacedSystemBets, action.meta],
      };
    }
    case REMOVE_SUCCESS_SYSTEM_BET_PLACED: {
      return {
        ...state,
        successPlacedSystemBets: [],
      };
    }
    case REMOVE_FAILED_SYSTEM_BET_PLACED: {
      return {
        ...state,
        failedPlacedSystemBets: [],
      };
    }
    case REMOVE_SPECIFIC_SUCCESS_SYSTEM_BET_PLACE: {
      return {
        ...state,
        successPlacedSystemBets: state.successPlacedSystemBets.filter(placedBet => placedBet.systemBetId !== action.meta),
      };
    }
    case DEQUEUE_ALL_TICKETS:
      return {
        ...state,
        queuedTickets: [],
      };
    default:
      return state;
  }
};
